module.exports = __webpack_public_path__ + "static/img/cae530fd.c10.7874eb4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cabins/rowdy-coyote/cae530fd.c10.jpg
// module id = Gcd8
// module chunks = 2